/**
 * Sprite Model
 * 
 * @param {any} data 
 * @returns 
 */
const sprite = (data) => {
    const obj = info(data);
    obj.json = json(data);
    return obj;
};

/**
 * 角色基本信息
 * 
 * @param {any} { name, md5 } 
 * @returns 
 */
const info = ({ name, md5, type, width, height }) => {
    return {
        name: name,
        md5: md5,
        type: type || 'sprite',
        tags: [],
        info: [width, height, 1]
    };
};

/**
 * 角色信息
 * 
 * @param {any} { name, costumes, sounds } 
 * @returns 
 */
const json = ({ name, costumes, sounds }) => {
    return {
        objName: name,
        sounds: sounds || [sound({ name: 'pop', md5: '83a9787d4cb6f3b7632b4ddfebf74367.wav' })],
        costumes: costumes,
        currentCostumeIndex: 0,
        scratchX: 0,
        scratchY: 0,
        scale: 1,
        direction: 90,
        rotationStyle: 'normal',
        isDraggable: false,
        indexInLibrary: 4,
        visible: true,
        spriteInfo: {}
    };
};

/**
 * 声音信息
 * 
 * @param {any} { name, md5 } 
 * @returns 
 */
const sound = ({ name, md5 }) => {
    return {
        name: name,
        format: '',
        rate: 11025,
        sampleCount: 258,
        soundID: 1,
        md5ext: md5,
        md5,
        data: null,
        dataFormat: 'wav',
        assetId: md5.split('.')[0]
    };
    // {
    //     "name": "A Bass",
    //     "md5": "c04ebf21e5e19342fa1535e4efcdb43b.wav",
    //     "sampleCount": 28160,
    //     "rate": 22050,
    //     "format": ""
    // }
};

/**
 * 造型基本信息
 * 
 * @param {any} { name, md5 } 
 * @returns 
 */
const costume = ({ name, md5, x, y }) => {
    return {
        costumeName: name,
        baseLayerID: -1,
        baseLayerMD5: md5,
        bitmapResolution: 1,
        rotationCenterX: x,
        rotationCenterY: y
    };
};



export default {
    info,
    json,
    sound,
    costume,
    sprite
};